import { Link } from '../i18n/LocalizedLink'
import type { ButtonHTMLAttributes, ReactNode } from 'react'
import type { LinkProps } from 'react-router-dom'
import './SiteButton.css'

export type SiteButtonVariant = 'accent' | 'dark' | 'light'
export type SiteButtonSize = 'standard' | 'plan' | 'compact' | 'small'

type SiteButtonStyleProps = {
  variant?: SiteButtonVariant
  size?: SiteButtonSize
  fullWidth?: boolean
  className?: string
  children: ReactNode
}

export type SiteButtonProps = SiteButtonStyleProps & Omit<
  ButtonHTMLAttributes<HTMLButtonElement>,
  'className' | 'children'
>

export type SiteButtonLinkProps = SiteButtonStyleProps & Omit<
  LinkProps,
  'className' | 'children'
>

function getButtonClassName({
  variant = 'accent',
  size = 'standard',
  fullWidth = false,
  className,
}: Omit<SiteButtonStyleProps, 'children'>) {
  return [
    'site-button',
    `site-button--${variant}`,
    `site-button--${size}`,
    fullWidth && 'site-button--full-width',
    className,
  ].filter(Boolean).join(' ')
}

export function SiteButton({
  variant = 'accent',
  size = 'standard',
  fullWidth = false,
  className,
  children,
  type = 'button',
  ...props
}: SiteButtonProps) {
  return (
    <button
      {...props}
      type={type}
      className={getButtonClassName({ variant, size, fullWidth, className })}
    >
      {children}
    </button>
  )
}

export function SiteButtonLink({
  variant = 'accent',
  size = 'standard',
  fullWidth = false,
  className,
  children,
  ...props
}: SiteButtonLinkProps) {
  return (
    <Link
      {...props}
      className={getButtonClassName({ variant, size, fullWidth, className })}
    >
      {children}
    </Link>
  )
}
